/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/ReverseGeocodingResult'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./ReverseGeocodingResult'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.PointResponseReverseGeocodingResult = factory(root.GisServerApis.ApiClient, root.GisServerApis.ReverseGeocodingResult);
  }
}(this, function(ApiClient, ReverseGeocodingResult) {
  'use strict';




  /**
   * The PointResponseReverseGeocodingResult model module.
   * @module model/PointResponseReverseGeocodingResult
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>PointResponseReverseGeocodingResult</code>.
   * @alias module:model/PointResponseReverseGeocodingResult
   * @class
   */
  var exports = function() {
    var _this = this;



  };

  /**
   * Constructs a <code>PointResponseReverseGeocodingResult</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PointResponseReverseGeocodingResult} obj Optional instance to populate.
   * @return {module:model/PointResponseReverseGeocodingResult} The populated <code>PointResponseReverseGeocodingResult</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('coord')) {
        obj['coord'] = ApiClient.convertToType(data['coord'], 'String');
      }
      if (data.hasOwnProperty('data')) {
        obj['data'] = ReverseGeocodingResult.constructFromObject(data['data']);
      }
    }
    return obj;
  }

  /**
   * @member {String} coord
   */
  exports.prototype['coord'] = undefined;
  /**
   * @member {module:model/ReverseGeocodingResult} data
   */
  exports.prototype['data'] = undefined;



  return exports;
}));



